import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button/ActionButton';
import apiClient from 'clients/apiClient';
import compose from 'recompose/compose';
import config from 'helpers/config';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { MailIcon } from 'assets/materialIcons/materialIcons';
import { connect } from 'react-redux';
import { paymentSlipFailure, paymentSlipSuccess } from 'store/actions/payment-slip/paymentSlipActions';

class SendPaymentSlip extends React.Component {
    state = {
        isLoading: false,
    };

    sendPaymentSlipRequest = () => {
        const { id, paymentSlipFailure, paymentSlipSuccess } = this.props;

        const url = `${ config.getApiBaseUrl() }/bookings/${ id }/payment-slip/send`;

        return apiClient.create(url).then(() => {
            const message = 'resources.orders.paymentSlip.send.success';

            return paymentSlipSuccess(message);
        }, (error) => {
            return paymentSlipFailure(error);
        }).then(() => {
            this.setState({
                isLoading: false,
            });
        });
    }

    sendVoucher = () => {
        this.setState({
            isLoading: true,
        }, () => {
            return this.sendPaymentSlipRequest();
        });
    }

    render() {
        const { style, translate } = this.props;
        const { isLoading } = this.state;

        return (
            <Button
                disabled={ isLoading }
                icon={ <MailIcon color={ theme.palette.doveGray } /> }
                onClick={ this.sendVoucher }
                style={ style }
                title={ translate('resources.orders.paymentSlip.send.title') }
            />
        );
    }
}

SendPaymentSlip.defaultProps = {
    style: {},
};

SendPaymentSlip.propTypes = {
    id: PropTypes.number.isRequired,
    paymentSlipFailure: PropTypes.func.isRequired,
    paymentSlipSuccess: PropTypes.func.isRequired,
    style: PropTypes.object,
    translate: PropTypes.func.isRequired,
};

const enhance = compose(
    connect(
        null,
        {
            paymentSlipFailure: paymentSlipFailure,
            paymentSlipSuccess: paymentSlipSuccess,
        }
    ),
    translate,
);

export default enhance(SendPaymentSlip);



// WEBPACK FOOTER //
// ./src/components/button/payment-slip/SendPaymentSlip.js